import * as React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { useAppSelector } from '../store';
import { Link } from 'react-router-dom';


const Responses = () => {

    // get bearer token from store
    const bearerToken = useAppSelector(state => state.bearerToken.value);

    //state variables
    const [surveyId, setSurveyId] = React.useState("");
    const [responseId, setResponseId] = React.useState("");
    const [responseString, setResponseString] = React.useState("");
    const [isError, setIsError] = React.useState(false);
    const [responseObject, setResponseObject] = React.useState<{ [key: string]: string; } | null>(null);

    // if view response button is clicked
    const getResponseData = async ()  => {
        try {
            setResponseString("");
            // check if responseId and surveyId look valid
            if (surveyId === "" || !surveyId.startsWith("SV_") || responseId === "" || !responseId.startsWith("R_")) {
                await setIsError(true);
                setResponseString("Enter valid survey id and response id");
                return;
            }
            await setIsError(false);
            // get request
            let dataResponse = await axios.get(`/api/responses/${surveyId}/${responseId}`,
            { headers: { 'token': bearerToken } });
            console.log(dataResponse);

            // handle response
            if ((typeof dataResponse.data === 'string' || dataResponse.data instanceof String) && (dataResponse.data.startsWith("Error"))) {
                await setIsError(true);
                setResponseString(dataResponse.data as string);
            } else {
                await setIsError(false);
                setResponseObject(dataResponse.data.result.values);
            }
                
                
        } catch (error) {
            await setIsError(true);
            setResponseString((error as Error).message);
            console.log(error);
        }
    };

    // called on the change of survey id input field
    const handleSurveyIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSurveyId(event.target.value);
    }

    // called on the change of response id input field
    const handleResponseIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setResponseId(event.target.value);
    }

    const createTable = () => {
        if (responseObject !== null) {
            return (
                <table className="table table-hover">
                    <tbody>
                        <tr>
                            <th>Field</th>
                            <th>Value</th>
                        </tr>
                        {Object.keys(responseObject).map((key) => {
                            return <tr key={key}>
                                <td>{key}</td>
                                <td>{responseObject![key]}</td>
                            </tr>
                        })}
                    </tbody>
                </table>
            )
        }
    }



    return (
        <div>
            {bearerToken 
                ? <div>
                    <h1>View Survey Response Data</h1>
                    <input type="text" placeholder="Enter Survey ID" value={surveyId} onChange={handleSurveyIdChange} />
                    <input type="text" placeholder="Enter Response ID" value={responseId} onChange={handleResponseIdChange} />
                    <button id="viewDataButton" onClick={getResponseData}>View Response Data</button>

                    {isError
                        ? <p className="errorMessage">{responseString}</p>
                        : <div>{createTable()}</div>
                    }

                  </div>

                : <p>Go to the <Link to="/">Home</Link> tab to login</p>
            }

        </div>
    )
};

export default connect()(Responses);
